import React from 'react';
import { useLocation } from 'react-router-dom';
import PageHeader from '../../tenant_portal/shared/PageHeader';
import Options from '../Options';
import {
  getCreateAccountEmailPathForPathname,
  getIntentLoginPathForPathname,
  isCreateAccountPathname,
} from '../RouteIntents';
import loginStyles from '../../../../stylesheets/components/login.module.scss';

const CreateAccount = () => {
  const location = useLocation();
  const signInPath = getIntentLoginPathForPathname(location.pathname);
  const email = new URLSearchParams(location.search).get('email') || '';
  const emailQueryParams = email !== '' ? { email } : undefined;

  return (
    <div className={loginStyles.loginRouteContent}>
      <PageHeader title="Create an account" includeBottomMargin={false} />
      <Options
        emailPath={getCreateAccountEmailPathForPathname(location.pathname)}
        emailQueryParams={emailQueryParams}
        createAccount
        encryptedEmail={
          isCreateAccountPathname(location.pathname) ? email : undefined
        }
        existingAccountActionTo={signInPath}
      />
    </div>
  );
};

export default CreateAccount;
